<header class="app-header">
    <div class="app-header-title">GenAI MicroService Dashboard</div>

    <button class="btn-secondary" (click)="logout()">
        <i class="bi bi-box-arrow-right"></i> Logout
    </button>
</header>